import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
export const IconIdEye01 = t0 => {
  const $ = _c(11);
  let height;
  let props;
  let size;
  let width;
  if ($[0] !== t0) {
    ({
      size,
      width,
      height,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = height;
    $[2] = props;
    $[3] = size;
    $[4] = width;
  } else {
    height = $[1];
    props = $[2];
    size = $[3];
    width = $[4];
  }
  const t1 = size ?? width ?? 24;
  const t2 = size ?? height ?? 24;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <g fill="currentColor" clipPath="url(#Icon_ID_Eye_01_svg__a)"><path d="M62.475 28.054C55.435 20.295 43.81 12.057 32 12.27S8.564 20.295 1.525 28.054a5.92 5.92 0 0 0 0 7.999C6.218 41.118 17.975 51.73 32 51.73c14.024 0 25.755-10.665 30.475-15.81a5.92 5.92 0 0 0 0-7.866M19.735 32a12.265 12.265 0 1 1 24.53 0 12.265 12.265 0 0 1-24.53 0" /><path d="M32 37.332a5.332 5.332 0 1 0 0-10.664 5.332 5.332 0 0 0 0 10.664" /></g>;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <defs><clipPath id="Icon_ID_Eye_01_svg__a"><path fill="currentColor" d="M0 0h64v64H0z" /></clipPath></defs>;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== props || $[8] !== t1 || $[9] !== t2) {
    t5 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64" width={t1} height={t2} {...props}>{t3}{t4}</svg>;
    $[7] = props;
    $[8] = t1;
    $[9] = t2;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};
IconIdEye01.displayName = 'IconIdEye01';